import React, { useState, useEffect } from 'react'
import {
  Form,
  Button,
  FormCheck,
  Row,
  Col,
  Card,
  Container,
} from 'react-bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import { BsArrowLeft, BsCheckLg, BsXLg, BsPerson, BsCalendar, BsPhone, BsEnvelope, BsGeoAlt, BsChatDots, BsBook, BsBuilding } from 'react-icons/bs'
import { LuGraduationCap } from 'react-icons/lu'
import { FaUser, FaUserTie } from 'react-icons/fa'
import ApiEndpoints, { BASE_URL } from './commonComponents/ApiEndpoints'
import toast from 'react-hot-toast'
import { useNavigate } from 'react-router-dom'
import Cookies from 'js-cookie'
import { useAuth } from './AuthContext'
import { useSidebar } from './SidebarContext'
import ProfileDropdown from './commonComponents/ProfileDropdown'
import { useInstitute } from './commonComponents/InstituteContext'

const AddNewEnquiry = () => {
  const { logout } = useAuth()
  const { isCollapsed } = useSidebar()
  const navigate = useNavigate()
  const [marginLeft, setMarginLeft] = useState('0px')
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' ? window.innerWidth <= 768 : false,
  )
  const { logo, name, id } = useInstitute();
  const [logoError, setLogoError] = useState(false)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 992) {
        const expandedWidth = 245
        const collapsedWidth = 85
        const gap = 1

        setMarginLeft(
          isCollapsed
            ? `${collapsedWidth + gap}px`
            : `${expandedWidth + gap}px`,
        )
      } else {
        setMarginLeft('0px')
      }

      setIsMobile(window.innerWidth <= 768)
    }

    handleResize()
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [isCollapsed])

  const [newEnquiry, setNewEnquiry] = useState({
    name: '',
    email: '',
    phone: '',
    course_id: '',
    message: '',
    dob: '',
    gender: '',
    address: '',
    mother_name: '',
    father_name: '',
    parents_number: '',
  })

  const [courses, setCourses] = useState([])

  useEffect(() => {
    ApiEndpoints.getAllCourses().then((res) => setCourses(res.data.data))
  }, [])

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setNewEnquiry((prev) => ({ ...prev, [name]: value }))
  }

  const handleSave = async (e) => {
    e.preventDefault()
    if (!id) {
      toast.error('No institute selected. Please switch institute from the header first.')
      return
    }
    const userLogged = Cookies.get('user')

    if (userLogged) {
      try {
        setLoading(true)

        const parsedUser = JSON.parse(userLogged)
        const token = parsedUser?.token
        const enquiry_taken_by = parsedUser?.name || parsedUser?.user_id

        const enquiryPayload = {
          ...newEnquiry,
          enquiry_taken_by,
          institute_id: Number(id),
        }

        const response = await ApiEndpoints.addEnquiry(enquiryPayload, token)

        // Reset form
        setNewEnquiry({
          name: '',
          email: '',
          phone: '',
          course_id: '',
          message: '',
          dob: '',
          gender: '',
          address: '',
          mother_name: '',
          father_name: '',
          parents_number: '',
        })

        toast.success(response.data.message)

        // Navigate back to EnquiryForm page
        navigate('/EnquiryForm')
      } catch (error) {
        toast.error(error.response?.data?.message || 'Something went wrong.')
      } finally {
        setLoading(false)
      }
    }
  }

  return (
    <>
      <div
        style={{
          marginLeft,
          transition: 'margin-left 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
          willChange: 'margin-left',
          WebkitTransition: 'margin-left 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
          position: 'relative',
          zIndex: 1,
          marginTop: '0px',
          marginRight: '0px',
          marginBottom: '0px',
          paddingLeft: isCollapsed ? '12px' : '12px',
          paddingRight: isCollapsed ? '12px' : '12px',
        }}
      >
        {/* Header */}
        <div
          className="container-fluid p-0"
          style={{
            marginTop: window.innerWidth < 992 ? '55px' : '-12px',
            paddingLeft: '0px',
            paddingRight: '0px',
          }}
        >
          <div style={{ marginLeft: isMobile ? '-13px' : '-40px' }}>
            <div
              className="d-flex justify-content-between align-items-center"
              style={{
                background: '#F3F4F6',
                paddingLeft: '28px',
                paddingRight: '28px',
                paddingTop: '12px',
                paddingBottom: '12px',
                overflow: 'visible',
                borderBottom: '1px solid #D1D3D4',
                width: '100%',
              }}
            >
              {/* Left: Logo, Title and Back Button */}
              <div className="d-flex align-items-center gap-3">
                {/* School Logo */}
                <div style={{
                  width: '40px',
                  height: '40px',
                  borderRadius: '50%',
                  overflow: 'hidden',
                  background: '#223843',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0,
                }}>
                  {!logoError ? (
                    <img
                      src={logo}
                      alt="School Logo"
                      style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                      onError={() => setLogoError(true)}
                    />
                  ) : (
                    <LuGraduationCap size={20} style={{ color: '#ffffff' }} />
                  )}
                </div>

                <h3
                  className="m-0 fw-bold"
                  style={{
                    letterSpacing: '-0.02em',
                    overflow: 'visible',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    fontSize: 'clamp(18px, 2.5vw, 22px)',
                    color: '#111827',
                    lineHeight: '1.2',
                    fontFamily: 'Inter, system-ui, sans-serif',
                  }}
                >
                  Add New Enquiry
                </h3>
              </div>

              {!isMobile && <ProfileDropdown logout={logout} />}
            </div>
          </div>
        </div>

        <Container
          className="mt-4"
          style={{
            paddingLeft: isCollapsed ? '32px' : '40px',
            paddingRight: '32px',
            paddingTop: '32px',
            paddingBottom: '32px',
            maxWidth: '1200px',
          }}
        >
          <Form onSubmit={handleSave}>
            <Row className="g-4">
              {/* Personal Details Card */}
              <Col md={6} className="d-flex">
                <Card
                  className="h-100 w-100"
                  style={{
                    border: '1px solid #D1D3D4',
                    borderRadius: '12px',
                    boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)',
                    overflow: 'hidden',
                  }}
                >
                  {/* Header with Icon */}
                  <div
                    style={{
                      background: 'linear-gradient(135deg, #223843 0%, #223843 100%)',
                      padding: '16px 24px',
                      borderBottom: '1px solid #D1D3D4',
                    }}
                  >
                    <div className="d-flex align-items-center gap-2">
                      <div
                        style={{
                          width: '36px',
                          height: '36px',
                          borderRadius: '10px',
                          backgroundColor: 'rgba(255, 255, 255, 0.2)',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          backdropFilter: 'blur(10px)',
                        }}
                      >
                        <BsPerson size={18} style={{ color: '#ffffff' }} />
                      </div>
                      <h5
                        style={{
                          margin: 0,
                          fontWeight: '700',
                          fontSize: '16px',
                          color: '#ffffff',
                          fontFamily: 'Inter, system-ui, sans-serif',
                        }}
                      >
                        Personal Details
                      </h5>
                    </div>
                  </div>
                  <Card.Body style={{ padding: '24px' }} className="text-start">
                    <Form.Group className="mb-3">
                      <Form.Label>Name *</Form.Label>
                      <Form.Control
                        type="text"
                        name="name"
                        value={newEnquiry.name}
                        onChange={handleInputChange}
                        placeholder="Enter name"
                        required
                      />
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Form.Label>Date of Birth *</Form.Label>
                      <Form.Control
                        type="date"
                        name="dob"
                        value={newEnquiry.dob}
                        onChange={handleInputChange}
                        required
                      />
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Form.Label>Gender *</Form.Label>
                      <div>
                        <Form.Check
                          inline
                          type="radio"
                          name="gender"
                          label="Male"
                          value="Male"
                          checked={newEnquiry.gender === 'Male'}
                          onChange={handleInputChange}
                          required
                        />
                        <Form.Check
                          inline
                          type="radio"
                          name="gender"
                          label="Female"
                          value="Female"
                          checked={newEnquiry.gender === 'Female'}
                          onChange={handleInputChange}
                        />
                        <Form.Check
                          inline
                          type="radio"
                          name="gender"
                          label="Other"
                          value="Other"
                          checked={newEnquiry.gender === 'Other'}
                          onChange={handleInputChange}
                        />
                      </div>
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Form.Label>Father's Name</Form.Label>
                      <Form.Control
                        type="text"
                        name="father_name"
                        value={newEnquiry.father_name}
                        onChange={handleInputChange}
                        placeholder="Enter father's name"
                      />
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Form.Label>Mother's Name</Form.Label>
                      <Form.Control
                        type="text"
                        name="mother_name"
                        value={newEnquiry.mother_name}
                        onChange={handleInputChange}
                        placeholder="Enter mother's name"
                      />
                    </Form.Group>
                  </Card.Body>
                </Card>
              </Col>

              {/* Contact & Course Details Card */}
              <Col md={6} className="d-flex">
                <Card
                  className="h-100 w-100"
                  style={{
                    border: '1px solid #D1D3D4',
                    borderRadius: '12px',
                    boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)',
                    overflow: 'hidden',
                  }}
                >
                  {/* Header with Icon */}
                  <div
                    style={{
                      background: 'linear-gradient(135deg, #10B981 0%, #059669 100%)',
                      padding: '16px 24px',
                      borderBottom: '1px solid #D1D3D4',
                    }}
                  >
                    <div className="d-flex align-items-center gap-2">
                      <div
                        style={{
                          width: '36px',
                          height: '36px',
                          borderRadius: '10px',
                          backgroundColor: 'rgba(255, 255, 255, 0.2)',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          backdropFilter: 'blur(10px)',
                        }}
                      >
                        <BsPhone size={18} style={{ color: '#ffffff' }} />
                      </div>
                      <h5
                        style={{
                          margin: 0,
                          fontWeight: '700',
                          fontSize: '16px',
                          color: '#ffffff',
                          fontFamily: 'Inter, system-ui, sans-serif',
                        }}
                      >
                        Contact & Course Details
                      </h5>
                    </div>
                  </div>
                  <Card.Body style={{ padding: '24px' }} className="text-start">
                    <Form.Group className="mb-3">
                      <Form.Label>Phone Number *</Form.Label>
                      <Form.Control
                        type="tel"
                        name="phone"
                        value={newEnquiry.phone}
                        onChange={handleInputChange}
                        placeholder="Enter phone number"
                        required
                      />
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Form.Label>Email</Form.Label>
                      <Form.Control
                        type="email"
                        name="email"
                        value={newEnquiry.email}
                        onChange={handleInputChange}
                        placeholder="Enter email"
                      />
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Form.Label>Parent's Number</Form.Label>
                      <Form.Control
                        type="tel"
                        name="parents_number"
                        value={newEnquiry.parents_number}
                        onChange={handleInputChange}
                        placeholder="Enter parent's phone number"
                      />
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Form.Label>Course</Form.Label>
                      <Form.Select
                        name="course_id"
                        value={newEnquiry.course_id}
                        onChange={handleInputChange}
                      >
                        <option value="">Select Course</option>
                        {courses.map((course) => (
                          <option key={course.id} value={course.id}>
                            {course.name}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Card.Body>
                </Card>
              </Col>
            </Row>

            <Row className="g-4 mt-0">
              {/* Address Card */}
              <Col md={6} className="d-flex">
                <Card
                  className="h-100 w-100"
                  style={{
                    border: '1px solid #D1D3D4',
                    borderRadius: '12px',
                    boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)',
                    overflow: 'hidden',
                  }}
                >
                  {/* Header with Icon */}
                  <div
                    style={{
                      background: 'linear-gradient(135deg, #14B8A6 0%, #0D9488 100%)',
                      padding: '16px 24px',
                      borderBottom: '1px solid #D1D3D4',
                    }}
                  >
                    <div className="d-flex align-items-center gap-2">
                      <div
                        style={{
                          width: '36px',
                          height: '36px',
                          borderRadius: '10px',
                          backgroundColor: 'rgba(255, 255, 255, 0.2)',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          backdropFilter: 'blur(10px)',
                        }}
                      >
                        <BsGeoAlt size={18} style={{ color: '#ffffff' }} />
                      </div>
                      <h5
                        style={{
                          margin: 0,
                          fontWeight: '700',
                          fontSize: '16px',
                          color: '#ffffff',
                          fontFamily: 'Inter, system-ui, sans-serif',
                        }}
                      >
                        Address
                      </h5>
                    </div>
                  </div>
                  <Card.Body style={{ padding: '24px' }} className="text-start">
                    <Form.Group className="mb-0">
                      <Form.Label>Address *</Form.Label>
                      <Form.Control
                        as="textarea"
                        name="address"
                        value={newEnquiry.address}
                        onChange={handleInputChange}
                        placeholder="Enter address"
                        rows={3}
                        required
                      />
                    </Form.Group>
                  </Card.Body>
                </Card>
              </Col>

              {/* Message Card */}
              <Col md={6} className="d-flex">
                <Card
                  className="h-100 w-100"
                  style={{
                    border: '1px solid #D1D3D4',
                    borderRadius: '12px',
                    boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)',
                    overflow: 'hidden',
                  }}
                >
                  {/* Header with Icon */}
                  <div
                    style={{
                      background: 'linear-gradient(135deg, #8B5CF6 0%, #7C3AED 100%)',
                      padding: '16px 24px',
                      borderBottom: '1px solid #D1D3D4',
                    }}
                  >
                    <div className="d-flex align-items-center gap-2">
                      <div
                        style={{
                          width: '36px',
                          height: '36px',
                          borderRadius: '10px',
                          backgroundColor: 'rgba(255, 255, 255, 0.2)',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          backdropFilter: 'blur(10px)',
                        }}
                      >
                        <BsChatDots size={18} style={{ color: '#ffffff' }} />
                      </div>
                      <h5
                        style={{
                          margin: 0,
                          fontWeight: '700',
                          fontSize: '16px',
                          color: '#ffffff',
                          fontFamily: 'Inter, system-ui, sans-serif',
                        }}
                      >
                        Message
                      </h5>
                    </div>
                  </div>
                  <Card.Body style={{ padding: '24px' }} className="text-start">
                    <Form.Group className="mb-0">
                      <Form.Label>Message</Form.Label>
                      <Form.Control
                        as="textarea"
                        name="message"
                        value={newEnquiry.message}
                        onChange={handleInputChange}
                        placeholder="Drop your message"
                        rows={3}
                      />
                    </Form.Group>
                  </Card.Body>
                </Card>
              </Col>
            </Row>

            <div className="d-flex justify-content-end gap-3 mt-4 pt-3" style={{ borderTop: '1px solid #E5E7EB' }}>
              <Button
                onClick={() => navigate('/EnquiryForm')}
                disabled={loading}
                style={{
                  backgroundColor: '#ffffff',
                  border: '1px solid #D1D3D4',
                  color: '#6b7280',
                  borderRadius: '8px',
                  padding: '12px 24px',
                  fontWeight: '600',
                  fontSize: '15px',
                  fontFamily: 'Inter, system-ui, sans-serif',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '8px',
                  transition: 'all 0.2s ease',
                  minWidth: '140px',
                }}
                onMouseEnter={(e) => {
                  if (!loading) {
                    e.currentTarget.style.backgroundColor = '#F3F4F6'
                    e.currentTarget.style.borderColor = '#9ca3af'
                    e.currentTarget.style.color = '#111827'
                    e.currentTarget.style.transform = 'translateY(-1px)'
                  }
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = '#ffffff'
                  e.currentTarget.style.borderColor = '#D1D3D4'
                  e.currentTarget.style.color = '#6b7280'
                  e.currentTarget.style.transform = 'translateY(0)'
                }}
              >
                <BsXLg size={16} />
                Cancel
              </Button>
              <Button
                type="submit"
                disabled={loading}
                style={{
                  backgroundColor: loading ? '#9ca3af' : '#10B981',
                  border: 'none',
                  color: '#ffffff',
                  borderRadius: '8px',
                  padding: '12px 24px',
                  fontWeight: '600',
                  fontSize: '15px',
                  fontFamily: 'Inter, system-ui, sans-serif',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '8px',
                  transition: 'all 0.2s ease',
                  minWidth: '160px',
                  boxShadow: loading ? 'none' : '0 2px 4px rgba(16, 185, 129, 0.2)',
                }}
                onMouseEnter={(e) => {
                  if (!loading) {
                    e.currentTarget.style.backgroundColor = '#059669'
                    e.currentTarget.style.transform = 'translateY(-1px)'
                    e.currentTarget.style.boxShadow = '0 4px 8px rgba(16, 185, 129, 0.3)'
                  }
                }}
                onMouseLeave={(e) => {
                  if (!loading) {
                    e.currentTarget.style.backgroundColor = '#10B981'
                    e.currentTarget.style.transform = 'translateY(0)'
                    e.currentTarget.style.boxShadow = '0 2px 4px rgba(16, 185, 129, 0.2)'
                  }
                }}
              >
                {loading ? (
                  <>
                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" style={{ width: '14px', height: '14px', borderWidth: '2px' }}></span>
                    Saving...
                  </>
                ) : (
                  <>
                    <BsCheckLg size={16} />
                    Save
                  </>
                )}
              </Button>
            </div>
          </Form>
        </Container>
      </div>
    </>
  )
}

export default AddNewEnquiry

